import { ApiClient } from "../ApiClient";

/**
 * This function will be used during account activation to get the account using the generated token
 */
export const getAccountByActivationToken = async (url, data) => {
  // ApiClient.post handles baseUrl, JSON stringification, and credentials.
  // Note: url here is the endpoint string passed from the component.
  return ApiClient.post(url, data);
};
